export const checkoutSearchParam = 'subscription'
export const checkoutSearchParamValues = {
	success: 'success',
	incomplete: 'incomplete',
	cancelled: 'cancelled',
}

// ToDo: move to searchParams.ts
